import type { RequestParams } from '@/shared/api';

export const USER_KEYS = {
  all: ['user'] as const,
  me: () => [...USER_KEYS.all, 'me'] as const,
  list: (params?: RequestParams) => [...USER_KEYS.all, 'list', params] as const,
  detail: (id: number | string) => [...USER_KEYS.all, 'detail', id] as const,
  contentMakers: (params?: { from?: string; to?: string }) =>
    [...USER_KEYS.all, 'content-makers', params] as const,
  contentMakerDetail: (params: { id: number; created_at_from?: string; created_at_to?: string }) =>
    [...USER_KEYS.all, 'content-makers', 'detail', params] as const,
  usersByType: (params?: { user_type?: string; page?: number; limit?: number; from?: string; to?: string }) =>
    [...USER_KEYS.all, 'by-type', params] as const,
};
